import { AntdButton, InputField, SelectInput } from "../../../blueplanitUtils/InputField";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faPen, faSync } from "@fortawesome/free-solid-svg-icons";
import { useEffect, useState } from "react";
import AddJobRequisition from "./AddJobRequisition";
import { CustomGridTable } from "../../../blueplanitUtils/CustomGridTable";
import { useDispatch, useSelector } from "react-redux";
import { getJobPostingInsightsAsync, getJobRequisitionsAsync } from "../../../Slices/hiringSlice";
import dayjs from "dayjs";
import { useNavigate, useParams } from "react-router-dom";
import JobRequisitionDetails from "./JobRequisitionDetails";
import { Card, Col, Modal, Row, Space, Tag, Tooltip, Typography } from "antd";
import { getOptionsByPath } from "../../../utilsdata";
import { ADD_EDIT_EMPLOYEE, EMPLOYEE_DEPARTMENT } from "../../../Dropdownmanager";
import { setLoader } from "../../../Slices/loaderSlice";

const { Title, Text } = Typography;

const statusColors = {
  "Requested": "#8C8C8C",               
  "In-progress": "#1677FF",              
  "In-review": "#FAAD14",                 
  "Published": "#52C41A",               
  "Interview In-progress": "#722ED1",   
  "Hiring In-progress": "#13C2C2",        
  "Hiring completed": "#237804",          
};

const JobRequisitionManagement = () => {
    const { id } = useParams();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const jobRequisition = useSelector((state) => state.hiring.jobRequisition)
    const refreshStatus = useSelector((state) => state.orders.refreshPage);
    const loginUser = useSelector((state) => state?.loginUserInfo?.loginUserDetails);
    const NestedDatabucket = useSelector((state) => state.dataBucket.NestedDatabucket);
    const insights = useSelector((state) => state.hiring.insights);

    const [selectedDepartment, setSelectedDepartment] = useState(
        loginUser?.department === "HR & Admin" ? [] : loginUser?.department
    );
    const [open, setOpen] = useState(false);
    const [designation, setDesignation] = useState("");
    const [selectedPostDetails, setSelectedPostDetails] = useState(null);
    const [viewPostDetails, setViewPostDetails] = useState(false);


    const handleOpen = () => {
        setOpen(true)
    }

    useEffect(() => {
        if (!refreshStatus) {
            const variables = {
                department:
                    loginUser?.department === "HR & Admin"
                        ? selectedDepartment?.length > 0
                            ? selectedDepartment
                            : null
                        : [loginUser.department],
                designation: designation || null

            };

            dispatch(getJobRequisitionsAsync(variables))
        }
    }, [dispatch, refreshStatus]);

    useEffect(() => {
        if (selectedPostDetails?.requisitionId) {
            dispatch(getJobPostingInsightsAsync(selectedPostDetails.requisitionId));
        }
    }, [dispatch, selectedPostDetails]);


    const columns = [
        {
            title: 'Requisition ID',
            dataIndex: 'requisitionId',
            key: 'requisitionId',
        },
        {
            title: 'Designation',
            dataIndex: 'designation',
            key: 'designation',
        },
        {
            title: 'Department',
            dataIndex: 'dept',
            key: 'dept',
        },
        {
            title: 'Location',
            dataIndex: 'location',
            key: 'location',
        },
        {
            title: 'Employment Type',
            dataIndex: 'employmentType',
            key: 'employmentType',
        },
        {
            title: 'Created Date',
            dataIndex: 'createdAt',
            key: 'createdAt',
            render: (value) => dayjs(parseInt(value)).format("DD-MM-YYYY")
        },
        {
            title: "Requested By",
            dataIndex: 'RequestedBy',
            key: 'RequestedBy'
        },
        {
            title: 'Status',
            dataIndex: 'status',
            key: 'status',
            render: (status) => (
                <Tag
                    color={statusColors[status]}
                    style={{ fontWeight: 500, borderRadius: 5, padding: "2px 8px" }}
                >
                    {status}
                </Tag>
            ),
        },
        {
            title: "Actions",
            render: (_, record) => (
                <Space>
                    <FontAwesomeIcon
                        icon={faEye}
                        style={{ cursor: "pointer" }}
                    onClick={() => {
                        setSelectedPostDetails(record)
                        setViewPostDetails(true);
                    }}
                    />

                    <FontAwesomeIcon
                        icon={faPen}
                        onClick={() => handleDetailPage(record?.id)}
                        style={{
                            cursor: "pointer",
                            fontSize: "14px",
                            color: "#1677ff",
                        }}
                    />
                </Space>
            ),
        },

    ]

    const [formData, setFormData] = useState({
        requisitionId: "",
        designation: "",
        department: "",
        location: "",
        employmentType: "",
        workMode: "",
        numberOfOpenings: "",
        experienceRequired: "",
        skillsRequired: [],
        jobDescription: "",
        jobResponsibilities: "",
        salaryRange: "",
        shift: "",
        reasonForHiring: "",
        notes: "",
        approvalStatus: "Pending"
    });


    const handleDetailPage = (record) => {
        navigate(`/JobRequisition/${record}`)
    }
   

    const handleSearch = () => {
        const variables = {
            department:
                loginUser?.department === "HR & Admin"
                    ? selectedDepartment?.length > 0
                        ? selectedDepartment
                        : null
                    : [loginUser.department],
            designation: designation || null

        };
        dispatch(getJobRequisitionsAsync(variables))
    }

    const clearFilters = () => {
        if (loginUser?.department === "HR & Admin") {
            setSelectedDepartment([]);
            setDesignation("");
            dispatch(getJobRequisitionsAsync({}));
        } else {
            setSelectedDepartment([loginUser?.department]);
            dispatch(getJobRequisitionsAsync({ department: [loginUser?.department] }));
        }
    };

    const handleSync = async () => {
        try {
            dispatch(setLoader(true));
            await dispatch(getJobRequisitionsAsync({}));
        }
        catch (error) {
            console.error('Error refetching candidate details', error);
        } finally {
            dispatch(setLoader(false));
        }
    }


    return (
        <div className="page-wrapper">
            <div className="content container-fluid">
                {(id !== undefined) ? <JobRequisitionDetails /> :
                    <>
                        {open && <AddJobRequisition setOpen={setOpen} />}
                        {!open &&
                            <>
                                <div
                                    className="d-flex"
                                    style={{
                                        justifyContent: "space-between",
                                        alignItems: "center",
                                        marginBottom: "14px"
                                    }}
                                >
                                    <div style={{ display: "flex", alignItems: "center", gap: "16px" }}>
                                        <div style={{ marginTop: "15px" }}>
                                            <SelectInput
                                                placeholder="Select Department(s)"
                                                style={{ width: 200 }}
                                                value={selectedDepartment}
                                                onChange={(value) => setSelectedDepartment(value)}
                                                mode={loginUser?.department === "HR & Admin" ? "multiple" : undefined}
                                                options={
                                                    loginUser?.department === "HR & Admin"
                                                        ? getOptionsByPath(NestedDatabucket, [ADD_EDIT_EMPLOYEE, EMPLOYEE_DEPARTMENT])
                                                        : [{ label: loginUser?.department, value: loginUser?.department }]
                                                }
                                                // allowClear={loginUser?.department === "HR & Admin" }
                                                allowClear={true}
                                            />
                                        </div>
                                        <InputField
                                            value={designation}
                                            onChange={(e) => setDesignation(e.target.value)}
                                            placeholder="Search Designation"
                                            style={{ width: 200, marginBottom: '3px' }}
                                            allowClear
                                        />

                                        <AntdButton
                                            type="primary"
                                            label="Search"
                                            onClick={handleSearch}
                                            style={{ marginBottom: '3px' }}
                                        />

                                        <AntdButton
                                            label="Cancel"
                                            onClick={clearFilters}
                                            style={{ marginBottom: '3px' }}
                                        />
                                        <Tooltip title="Sync Now">
                                            <FontAwesomeIcon
                                                icon={faSync}
                                                style={{
                                                    fontSize: '18px',
                                                    color: '#1890ff',
                                                    cursor: 'pointer',
                                                    margin: '8px'
                                                }}
                                                onClick={handleSync}
                                            />
                                        </Tooltip>
                                    </div>

                                    <AntdButton
                                        label="Create New Job Request"
                                        color="primary"
                                        variant="solid"
                                        htmlType="submit"
                                        style={{ color: "white", marginBottom: '3px' }}
                                        onClick={handleOpen}
                                    />
                                </div>

                                <div className="row">
                                    <div className="col-md-12">
                                        <div className="table-responsive">
                                            <CustomGridTable
                                                rowKey="id"
                                                style={{ width: "100%", tableLayout: "auto" }}
                                                columns={columns}
                                                dataSource={jobRequisition || []}
                                                pagination={true}
                                                loading={false}
                                                scroll={{ x: false }}
                                                size="small"
                                           
                                            />
                                        </div>

                                    </div>
                                </div>

                                {viewPostDetails && (
                                    <Modal
                                        open={viewPostDetails}
                                        onCancel={() => setViewPostDetails(false)}
                                        footer={null}
                                        width={700}
                                        centered
                                    >
                                        {insights && (
                                            <Card
                                                title={
                                                    <Space
                                                        direction="vertical"
                                                        style={{
                                                            width: "100%",
                                                        }}
                                                    >

                                                        <Space align="center">
                                                            <div
                                                                style={{
                                                                    width: 40,
                                                                    height: 40,
                                                                    borderRadius: "50%",
                                                                    background: "#1677ff20",
                                                                    display: "flex",
                                                                    justifyContent: "center",
                                                                    alignItems: "center",
                                                                }}
                                                            >
                                                                <Typography.Text
                                                                    strong
                                                                    style={{
                                                                        fontSize: 18,
                                                                        color: "#1677ff",
                                                                    }}
                                                                >
                                                                    B
                                                                </Typography.Text>
                                                            </div>

                                                            <Typography.Title
                                                                level={5}
                                                                style={{
                                                                    margin: 0,
                                                                    padding: 0,
                                                                    fontWeight: "bold",
                                                                }}
                                                            >
                                                                BLUEPLANIT SERVICES PVT. LTD
                                                            </Typography.Title>
                                                        </Space>

                                                        <Typography.Text
                                                            style={{
                                                                background: "linear-gradient(90deg, #1677ff, #00c5fb )",
                                                                WebkitBackgroundClip: "text",
                                                                color: "transparent",
                                                                fontSize: 16,
                                                                fontWeight: 700,
                                                                marginTop: 8, 
                                                            }}
                                                        >
                                                            {insights?.jobTitle}
                                                        </Typography.Text>
                                                    </Space>
                                                }
                                            >
                                                <Row gutter={[16, 16]}>
                                                    {[
                                                        { label: "Total Applications", value: insights.total, color: "#1677ff" },
                                                        { label: "Screening", value: insights.screening, color: "#fa8c16" },
                                                        { label: "Interview", value: insights.interview, color: "#52c41a" },
                                                        { label: "Offer", value: insights.offer, color: "#fadb14" },
                                                        { label: "Hired", value: insights.hired, color: "#2f54eb" },
                                                        { label: "Rejected", value: insights.rejected, color: "#ff4d4f" }
                                                    ].map((card) => (
                                                        <Col span={8} key={card.label}>
                                                            <Card
                                                                style={{
                                                                    borderLeft: `5px solid ${card.color}`,
                                                                    background: "#fafafa",
                                                                    borderRadius: 8,
                                                                }}
                                                            >
                                                                <Title level={3} style={{ margin: 0 }}>{card.value}</Title>
                                                                <Text type="secondary">{card.label}</Text>
                                                            </Card>
                                                        </Col>
                                                    ))}
                                                </Row>
                                            </Card>
                                        )}

                                        {/* </Card> */}
                                    </Modal>
                                )}

                            </>

                        }

                    </>
                }

            </div>
        </div>

    )
};

export default JobRequisitionManagement;